import { useState } from "react";

export default function UserManagement() {
  const [users, setUsers] = useState([
    {
      id: 1,
      firstName: "Adem",
      lastName: "Mete",
      email: "adem@example.com",
      role: "learner",
      groups: ["NSW", "Plumbing"],
    },
    {
      id: 2,
      firstName: "Sara",
      lastName: "Nguyen",
      email: "sara@example.com",
      role: "manager",
      groups: ["VIC"],
    },
  ]);

  const deleteUser = (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this user?");
    if (confirmed) {
      setUsers(users.filter((user) => user.id !== id));
    }
  };

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold">User Management</h1>

      <table className="w-full border-collapse mt-4">
        <thead>
          <tr className="bg-gray-100 text-left text-sm font-medium text-gray-700">
            <th className="p-2">Name</th>
            <th className="p-2">Email</th>
            <th className="p-2">Role</th>
            <th className="p-2">Groups</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-b hover:bg-gray-50 text-sm">
              <td className="p-2">{user.firstName} {user.lastName}</td>
              <td className="p-2">{user.email}</td>
              <td className="p-2 capitalize">{user.role}</td>
              <td className="p-2">{user.groups.join(", ")}</td>
              <td className="p-2">
                <button
                  onClick={() => deleteUser(user.id)}
                  className="text-red-600 hover:underline text-sm"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
